import { useCallback, useEffect, useState } from "react";
import { useNetlifySDK } from "../use_netlify_sdk.js";
import { Button } from "./Button/Button.jsx";
import { ButtonGroup } from "./Button/ButtonGroup.jsx";
import { Card, CardTitle } from "./vendor/Card/main.js";

export const ProviderAuthCard = () => {
  const sdk = useNetlifySDK();
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmingDisconnect, setIsConfirmingDisconnect] = useState(false);
  const isConnected = sdk.context.auth.providerToken !== null;

  useEffect(() => {
    // FIXME(ndhoule): This lint rule has a point, and we should fix this.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsConfirmingDisconnect(false);
    setIsLoading(false);
  }, [setIsConfirmingDisconnect, setIsLoading]);

  const onClickConnect = useCallback(() => {
    setIsLoading(true);
    void sdk.beginProviderAuthFlow();
  }, [sdk, setIsLoading]);

  const onClickDisconnect = useCallback(() => {
    setIsConfirmingDisconnect(true);
  }, [setIsConfirmingDisconnect]);

  const onConfirmDisconnect = useCallback(() => {
    setIsLoading(true);
    void sdk.disconnectProviderAuth();
  }, [sdk, setIsLoading]);

  const onCancelDisconnect = useCallback(() => {
    setIsConfirmingDisconnect(false);
  }, [setIsConfirmingDisconnect]);

  return (
    <Card>
      <CardTitle>
        Your Netlify account is {isConnected ? "" : "not "}connected to{" "}
        {sdk.extension.name}
      </CardTitle>

      <ButtonGroup className="tw-mt-4">
        {!isConnected && (
          <Button onClick={onClickConnect} loading={isLoading}>
            {isLoading ? "Connecting" : "Connect"}
          </Button>
        )}

        {isConnected && !isConfirmingDisconnect && (
          <Button onClick={onClickDisconnect}>Disconnect</Button>
        )}

        {isConnected && isConfirmingDisconnect && (
          <>
            <Button
              onClick={onConfirmDisconnect}
              loading={isLoading}
              variant="danger"
            >
              Confirm Disconnect
            </Button>
            <Button
              disabled={isLoading}
              onClick={onCancelDisconnect}
              level="secondary"
            >
              Cancel
            </Button>
          </>
        )}
      </ButtonGroup>
    </Card>
  );
};
